import { useEffect, useState } from 'react';

export default function ScrollTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="回到顶部"
      className={`fixed bottom-6 right-6 z-50 flex h-12 w-12 items-center justify-center rounded-full border border-background-200 bg-background-50 text-foreground-800 shadow-none transition-all hover:bg-primary-500 hover:text-background-50 ${
        show ? 'opacity-100' : 'pointer-events-none opacity-0'
      }`}
    >
      <i className="ri-arrow-up-line text-xl leading-none" />
    </button>
  );
}